export const isEmptyObject = (obj: any): boolean => obj.constructor === Object && Object.keys(obj).length === 0
